export async function fetchAircallRecording(callId: string): Promise<string | null> {
  try {
    console.log('🔄 Calling Make webhook with call_id:', callId);
    
    const response = await fetch('https://hook.eu2.make.com/kqcoosfpeovjd85f6jgkryxtotteo4kk', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        call_id: callId
      })
    });

    console.log('📞 Make webhook response status:', response.status);
    
    if (!response.ok) {
      console.error('❌ Make webhook error:', response.status, response.statusText);
      return null;
    }

    const data = await response.json();
    console.log('📞 Make webhook response data:', data);
    
    // Le webhook Make renvoie { "url": "..." }
    return data.url || null;
  } catch (error) {
    console.error('❌ Error calling Make webhook:', error);
    return null;
  }
}